import { ICanvasStep } from '../../interfaces'
import { isUndefined } from 'lodash'

export const containsEndTile = (steps: ICanvasStep[]) => steps.some(step => !isUndefined(step.finish))
